import { render, staticRenderFns } from "./GoldlockerContent.vue?vue&type=template&id=20c9f7b0"
import script from "./GoldlockerContent.vue?vue&type=script&lang=js"
export * from "./GoldlockerContent.vue?vue&type=script&lang=js"
import style0 from "./GoldlockerContent.vue?vue&type=style&index=0&id=20c9f7b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports